//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import HtmlContent from 'components/Shared/HtmlContent/Index'
import colors from 'components/utils/colors'

const StyledFieldText = styled.div`
  font-size: 14px;
  white-space: pre-line;
  word-break: break-word;
  color: ${colors.secondary20};
`

const StyledNoDataText = styled.section`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.secondary70};
`

const FieldComponent = ({ readOnlyFieldValue, isHtml }) => {
  const { t } = useTranslation()

  if (readOnlyFieldValue === '') {
    return <StyledNoDataText data-test='read-only-no-data'>{t('common.noTableData')}</StyledNoDataText>
  } else if (isHtml) {
    return <HtmlContent html={readOnlyFieldValue} />
  } else {
    return <StyledFieldText data-test='read-only-value'>{readOnlyFieldValue}</StyledFieldText>
  }
}

FieldComponent.propTypes = {
  readOnlyFieldValue: PropTypes.string,
  isHtml: PropTypes.bool,
}

const ReadOnlyField = ({ name, isHtml, readOnlyFieldValue, shouldUseValue }) => {
  return (
    <Field
      name={name}
    >
      {({ input, meta }) => {
        const value = shouldUseValue ? input.value : readOnlyFieldValue
        return (
          <FieldComponent
            readOnlyFieldValue={value}
            isHtml={isHtml}
          />
        )
      }}
    </Field>
  )
}

ReadOnlyField.propTypes = {
  name: PropTypes.string,
  isHtml: PropTypes.bool,
  readOnlyFieldValue: PropTypes.string,
  shouldUseValue: PropTypes.bool,
}

export default ReadOnlyField
